export { default as useSetupCtcLocally } from './useSetupCtcLocally';
